import React, {ReactNode, ReactNodeArray} from 'react'; 
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadCustomerDataUsageBlockData from '../../../Models/Content/AbroadCustomerDataUsageBlockData';
import AbroadCustomerDataUsageMain from './AbroadCustomerDataUsageMain';


export default class AbroadCustomerDataUsageBlock extends EpiComponent<AbroadCustomerDataUsageBlockData>
{

    public render() : ReactNode | ReactNodeArray | null
    {
        return (
            <AbroadCustomerDataUsageMain iContent={this.props.data} context={this.getContext()}  />
        );
    }
}